// extracted by mini-css-extract-plugin
export var coverStyle = "content_cover_artwork-module--coverStyle---pjQT";
export var wrapperStyle = "content_cover_artwork-module--wrapperStyle--9uMVN";